import type { GraphChange } from './graphRefresh';

const nodes = (count: number) => `${count} ${count === 1 ? 'node' : 'nodes'}`;

/**
 * "Graph updated · +N nodes · −M nodes" for a moment after a newer snapshot arrives. It sits in the header's bottom
 * margin, so the canvas does not move when it comes and goes. The live region is always there, so the change is
 * announced.
 */
export function GraphUpdateNote({ change }: { change: GraphChange | null }) {
  return (
    <div className="relative">
      <p role="status" className="absolute -top-7 left-0 text-sm text-zinc-600 dark:text-zinc-300">
        {change && (
          <>
            Graph updated · +{nodes(change.added)} · −{nodes(change.removed)}
          </>
        )}
      </p>
    </div>
  );
}
